import service from "@/store/services/external-apis-service";

const state = {};

const mutations = {};

const actions = {
  ba_getCep({ _ }, cep) {
    return service.ba_getCep(cep).then((response) => {
      return response;
    });
  },
};

const getters = {};

const external_apis = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default external_apis;
